import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import autoBind from "react-autobind";
import { Row, Col } from "react-bootstrap";
import DDadosItem from "@common/components/ddados/ddados.item";
import { ddadosValidar as DDados } from "../validar.ddados";
import validarSelector from "../store/validar.selectors";
import validarActions from "../store/validar.actions";
import Form from "@common/externos/components/validation/form.validation";
import Card from "@common/externos/components/card/card.externo";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({
      name: "servicoEmpresa.crachaAmbulante.validar"
    });
  }

  componentDidMount() {
    const { validar } = this.props.validarSelector;

    if (!validar.tokenRecaptcha)
      this.onCancel();
  }

  render() {
    const { Campos, title } = DDados;
    const { validar } = this.props.validarSelector;

    return (
      <Card>
        <Form
          onCancel={this.onCancel}
          prefix="V"
        >
          {form => (
            <div className="p-3">
              <Row>
                <Col lg={2} className="text-center">
                  <img className={"img-thumbnail"} src={validar.DadosAmbulante.FotoPerfil ? "data:image/png;base64," + validar.DadosAmbulante.FotoPerfil : undefined}></img>
                </Col>

                <Col>
                  <Row>
                    <Col lg={"4"}>
                      <DDadosItem
                        name="NumeroCracha"
                        {...Campos.NumeroCracha}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"4"}>
                      <DDadosItem
                        name="CpfCnpj"
                        {...Campos.CpfCnpj}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"4"}>
                      <DDadosItem
                        name="Ccm"
                        {...Campos.CCM}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"12"}>
                      <DDadosItem
                        name="Nome"
                        {...Campos.Nome}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"4"}>
                      <DDadosItem
                        name="Praia"
                        {...Campos.Praia}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"8"}>
                      <DDadosItem
                        name="Produto"
                        {...Campos.Produto}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                    <Col lg={"6"}>
                      <DDadosItem
                        name="Vencimento"
                        {...Campos.Vencimento}
                        isView={true}
                        state={validar.DadosAmbulante}
                        Desabilitado={true}
                      />
                    </Col>
                    <Col lg={"6"}>
                      <DDadosItem
                        name="CodigoVerificacao"
                        {...Campos.CodigoVerificacao}
                        isView={true}
                        state={validar.DadosAmbulante}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Form>
      </Card>
    );
  }
}

export default connect({
  actions: {
    validarActions
  },
  selectors: {
    validarSelector
  }
})(Container);
